<div class="spinner" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>

<div class="container-fluid d-flex justify-content-center align-items-center min-vh-100">
  <mat-card class="login-card">
    <div class="row">
      <!-- Logo -->
      <div class="col-6">
        <img src="/assets/img/LOGOTIPO.png" alt="Icono" class="logo">
      </div>

      <!-- Formulario -->
      <div class="col-6">
        <div class="formulario text-center">
          <span class="subtitle">Iniciar Sesión</span>
          <form autocomplete="off" (ngSubmit)="login()" [formGroup]="formulario">
            <!-- Campo Usuario -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Usuario</mat-label>
              <input matInput type="text" formControlName="usr">
              <mat-icon matSuffix color="primary">person</mat-icon>
            </mat-form-field>

            <!-- Campo Contraseña -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Contraseña</mat-label>
              <input matInput type="password" formControlName="pass">
              <mat-icon matSuffix color="primary">lock</mat-icon>
            </mat-form-field>

            <!-- Botones -->
            <button mat-flat-button color="primary" class="btn-submit" type="submit">
              Entrar
            </button>
            <button mat-stroked-button color="primary" class="btn-secondary" (click)="irAEncuesta()">
              <mat-icon>poll</mat-icon> Encuestas
            </button>


          </form>
          <br>
          <a href="#" class="forgot-password">¿Olvidó su contraseña?</a>
        </div>
      </div>
    </div>
  </mat-card>
</div>